import fetch, { doPost, doGet, doDelete, doPut, doGetFile } from '../../tools/axios'

export default {
  getLoginUserInfo (cb) {
    return fetch('get', '/user/info', {}, cb)
  },
  getUserInfo (id, cb) {
    return fetch('get', `/user/${id}`, {}, cb)
  },
  getUserGifts (page, userId, status, type, noRequestList = true, cb = null, perPage = 10) {
    const url = `/gifts${noRequestList ? '/home' : ''}?page=${page}&user_id=${userId}&status=${status}&type=${type}&perPage=${perPage}`
    return fetch('get', url, {}, cb)
  },
  getUserNeedDonates (page, userId, cb) {
    const url = `/needDonate?page=${page}&user_id=${userId}&status=sent,finished,overdue,thanks&perPage=10`
    return fetch('get', url, {}, cb)
  },
  getUserNeeds (page, userId, cb, perPage = 10, status = '') {
    const url = `/needs/home?page=${page}&user_id=${userId}&perPage=${perPage}&on_pool_only=0&status=${status}`
    return fetch('get', url, {}, cb)
  },
  getUserRequests (page, userId, status, cb, keyword = '') {
    const url = `/giftRequest?page=${page}&user_id=${userId}&perPage=10&status=${status}&keyword=${keyword}`
    return fetch('get', url, {}, cb)
  },
  getTraceThing (type, page, perPage, cb) {
    const _type = {
      user: 'Users',
      gift: 'Gifts',
      need: 'Needs',
      provision: 'Provisions'
    }[type]
    const url = `/user/trace${_type}?page=${page}&perPage=${perPage}`
    return fetch('get', url, {}, cb)
  },
  unTraceThing (id, type, cb) {
    const key = {
      user: 'trace_user_id',
      gift: 'gift_id',
      need: 'need_id',
      provision: 'love_provision_id'
    }[type]
    const url = type === 'provision' ? 'love/provisions' : (type === 'user' ? 'user' : `${type}s`)
    const data = {
      [key]: id
    }
    return fetch('post', `/${url}/untrace`, {data}, cb)
  },
  changePassword (oldpw, newpw, cb) {
    const data = {
      old_password: oldpw,
      new_password: newpw
    }
    return fetch('post', '/user/changePassword', {data}, cb)
  },
  resetpassword (email, cb) {
    const data = {
      email
    }
    return fetch('post', '/user/forgetPassword', {data}, cb)
  },
  // 手机註冊用户的找回密码
  resetcellphonepassword (cellphone, password, repeatPassword, token, cb) {
    const data = {
      cellphone,
      password,
      repeat_password: repeatPassword,
      token
    }
    return fetch('post', '/phone/forgetPassword', {data}, cb)
  },
  // 编辑资料
  modify (data, cb) {
    return fetch('post', '/user/modify', {data}, cb)
  },
  sendCodeVerifyCellPhone (cellphone, cb) {
    const data = {
      cellphone
    }
    return fetch('post', '/user/verifyCellphoneSendCode', {data}, cb)
  },
  confirmVerifyCellPhone (cellphone, token, cb) {
    const data = {
      cellphone,
      token
    }
    return fetch('post', '/user/verifyCellphone', {data}, cb)
  },
  sendVerifyEmail (email, cb) {
    return fetch('post', '/user/verifyEmailSend', {data: {email}}, cb)
  },
  confirmVerifyEmail (usrHash, token, cb) {
    return fetch('get', `/user/verifyEmail?user_id=${usrHash}&token=${token}`, {}, cb)
  },
  confirmVerifyName (idImage, docImage, cb) {
    const data = {
      front: idImage,
      back: docImage
    }
    return fetch('post', '/user_identities', {data}, cb)
  },
  confirmVerifyLoveBox (code, cb) {
    const data = {
      invite_code: code
    }
    return fetch('post', '/love/user/bind', {data}, cb)
  },
  // 会员变更
  changeUserRoles (data, cb) {
    return fetch('post', '/user_roles', {data}, cb)
  },
  // 暱稱不可與其他人重複
  isNicknameBeTaken (nickname) {
    return fetch('get', `/users/existsNickname?nickname=${nickname}`)
  },
  // 好壞名單
  getUserMarks (type, page, perPage, cb) {
    return fetch('get', `/user_marks?type=${type}&page=${page}&perPage=${perPage}`, {}, cb)
  },
  cancelMark (userId, cb) {
    const data = {
      mark_user_id: userId
    }
    return fetch('post', '/user/cancelMark', {data}, cb)
  },
  makeMarks (content, userId, type, cb) {
    const data = {
      content,
      mark_user_id: userId,
      type
    }
    return fetch('post', '/user/mark', {data}, cb)
  },
  traceUser (isTrace, userId, cb) {
    const data = {
      trace_user_id: userId
    }
    return fetch('post', `/user/${isTrace ? 'untrace' : 'trace'}`, {data}, cb)
  },
  updateConnect (data, cb) {
    return fetch('post', '/transfer', {data}, cb)
  },
  resetMailPassword (userId, code, password) {
    return doPost('/user/resetPassword', {
      user_id: userId,
      token: code,
      password
    })
  },
  getUserRegisterCode () {
    return doGet('/users/getRegisterCode')
  },
  getRegisterCodeInviteRecords (start, end) {
    return doGet(`/users/getRegisterCodeInviteRecords?start=${start}&end=${end}`)
  },
  getInviterByRegisterCode (registerCode) {
    return doGet(`/users/getInviterByRegisterCode?register_code=${registerCode}`)
  },
  getUserAnnualReport (userId, year) {
    return doGet(`/annual_report/stat?user_id=${userId}&year=${year}`)
  },
  unsubscribeEmailNotify (email, type) {
    return doGet(`/users/unsubscribeEdm?email=${email}&type=${type}`)
  },
  addAddress (data) {
    return doPost('/addresses', data)
  },
  removeAddress (addressId) {
    return doDelete(`/addresses/${addressId}`)
  },
  updateAddress (addressId, data) {
    return doPut(`/addresses/${addressId}`, data)
  },
  getMyAddresses () {
    return doGet(`/my/addresses`)
  },
  getMyHaveSucceedPalmboxOrder () {
    return doGet(`/my/haveSucceedPalmbox`)
  },
  getAccountRisk () {
    return doGet('/my/haveRisk')
  },
  getMyWalletPoints () {
    return doGet('/my/wallet')
  },
  getMyWalletChargeOrders (page, perPage) {
    return doGet(`/my/paymentOrders?page=${page}&perPage=${perPage}`)
  },
  getMyWalletRecords (page, perPage) {
    return doGet(`/my/walletRecords?type=2,3,4,7&page=${page}&perPage=${perPage}`)
  },
  getWalletChargeParams (payType, amount, name, phone, email, invoiceInfo) {
    return doPost('/wallet/payNow/charge', {
      pay_type: payType,
      amount,
      username: name,
      cellphone: phone,
      email,
      ...invoiceInfo,
      auto_invoice: 1
    })
  },
  setWalletPassCode (passcode) {
    return doPost('/my/walletPassCode', {
      pass_code: passcode
    })
  },
  invoicePaymentOrder (orderId, data) {
    return doPost(`/wallet/paymentOrders/${orderId}/invoice`, data)
  },
  checkWalletPassCode (passcode) {
    return doPost('/wallet/checkPassCode', {
      pass_code: passcode
    })
  },
  resetWalletPassCode (cellphone, token, passcode) {
    return doPost('/wallet/resetPassCode', {
      cellphone,
      token,
      pass_code: passcode
    })
  },
  getWalletChargeCount () {
    return doGet('/wallet/chargeCount')
  },
  walletAtmCharge (amount, name, phone, email, invoiceInfo) { // atm 背景交易
    return doPost('/wallet/payNow/atm/charge', { amount, username: name, cellphone: phone, email, ...invoiceInfo, auto_invoice: 1 })
  },
  getMySponsorRecords (page, perPage) {
    return doGet(`/my/sponsors?page=${page}&perPage=${perPage}`)
  },
  getUserOverview (userId) {
    return doGet(`/users/${userId}/overview`)
  },
  getMyCouponRecords (status, page, perPage) {
    return doGet(`/wallet/couponRecords?status=${status}&page=${page}&perPage=${perPage}`)
  },
  getAvailableCouponRecords (amount, scene) {
    return doGet(`/wallet/couponRecords/available?amount=${amount}&scene=${scene}`)
  },
  getCompanyProfile (userId) {
    return doGet(`/love/companies/${userId}/profile`)
  },
  getBenefitedCommonweals (userId, page, perPage = 20) {
    return doGet(`/love/companies/${userId}/commonweals?page=${page}&perPage=${perPage}`)
  },
  getCarbonLabellingInfo (code) {
    return doGet(`/carbonLabelling/getInfoByCode?code=${code}`)
  },
  bindCarbonLabelling (code, employeeNo, name) {
    return doPost(`/carbonLabelling/bind`, { code, employee_no: employeeNo })
  },
  deactivate (password) {
    return doPost('/user/deactivate', { password })
  },
  activate (token) {
    return fetch('post', '/user/activate', { headers: { 'Authorization': `Bearer ${token}` } })
  },
  getFestivalMedalList (page, festivalId, userId = '', perPage = 10) {
    return doGet(`/medal_records/list?festival_id=${festivalId}&user_id=${userId}&perPage=${perPage}&page=${page}`)
  },
  getDefaultAddress (userId) {
    return doGet(`/user/defaultAddress?user_id=${userId}`)
  },
  getRecycleCompanyInfo (id) {
    return doGet(`/recycle-companies/${id}`)
  },
  getRecycleCompanyInfoByUserId (userId) {
    return doGet(`/recycle-companies/${userId}/info`)
  },
  updateRecycleCompanyInfo (id, data) {
    return doPut(`/recycle-companies/${id}`, data)
  },
  // 企業品牌簽名檔（logo、簡介、官網）
  // 欄位需與後端 recycle_id_brand_signature 一致：logo / intro / website
  getBrandSignature () {
    return doGet('/my/recycleIdBrandSignature')
  },
  updateBrandSignature (data) {
    return doPost('/my/recycleIdBrandSignature', data)
  },
  // 检查邮箱是否已註冊
  checkSignupEmail (data = {}) {
    // data格式： { 'email': 'mbxust0901@163.com' }
    return doPost(`/user/checkSignupEmail`, data)
  },
  // 獲取我的服務訂購記錄
  getMyCarbonAccountOrders (data = { page: 1, perPage: 40 }) {
    return doGet('/my/recycleIdOrders', data)
  },
  getThankTemplates (page, perPage = 20) {
    return doGet(`/thank_templates?page=${page}&perPage=${perPage}`)
  },
  addThankTemplate (data) {
    return doPost('/thank_templates', data)
  },
  removeThankTemplate (thankId) {
    return doDelete(`/thank_templates/${thankId}`)
  },
  updateThankTemplate (thankId, data) {
    return doPut(`/thank_templates/${thankId}`, data)
  },
  getGreetPointBalance () {
    return doGet('/green_point/balance')
  },
  exchangeGreetPoint (amount) {
    return doPost('/wallet/charge', { amount, pay_method: 'greenpoint' })
  },
  // ========== 品牌好物管理（企業端）==========
  // 品牌好物列表（統一 status 篩選：訂單態/禮物態）
  // shipsnFrom / shipsnTo：寄件單建立時間區間（訂單態篩選用，格式 YYYY-MM-DD）
  getBrandGifts (status, page, perPage = 15, keyword = '', shipsnFrom = '', shipsnTo = '', cb) {
    let url = `/brandGifts?status=${status}&page=${page}&perPage=${perPage}${keyword ? `&keyword=${encodeURIComponent(keyword)}` : ''}`
    if (shipsnFrom) {
      url += `&shipsn_created_at_from=${shipsnFrom}`
    }
    if (shipsnTo) {
      url += `&shipsn_created_at_to=${shipsnTo}`
    }
    return fetch('get', url, {}, cb)
  },
  // 某品牌好物底下的索取列表（分頁，後端 perPage 上限 50）
  // 列表第 1 頁已由 getBrandGifts 的 nested orders 預覽帶回，此接口用於第 2 頁之後
  // status / shipsn 區間需與列表當前篩選一致，否則翻頁後資料口徑會與第 1 頁不同
  getBrandGiftOrders (giftId, page, perPage = 50, status = '', shipsnFrom = '', shipsnTo = '', cb) {
    let url = `/brandGifts/${giftId}/orders?page=${page}&perPage=${perPage}`
    if (status) {
      url += `&status=${status}`
    }
    if (shipsnFrom) {
      url += `&shipsn_created_at_from=${shipsnFrom}`
    }
    if (shipsnTo) {
      url += `&shipsn_created_at_to=${shipsnTo}`
    }
    return fetch('get', url, {}, cb)
  },
  // 批量生成運單號
  // giftRequestIds：指定的索取單；giftIds：整個品牌好物的所有待處理索取單
  // 索取單分頁載入（每頁 50），整批處理單一好物時必須用 giftIds，
  // 只送已載入頁的 giftRequestIds 會漏掉尚未下拉的索取單
  batchCreateShipSn ({ giftRequestIds = [], giftIds = [], ecOrderNo = '' }, cb) {
    return fetch('post', '/brandGifts/requests/batchCreateShipSn', { data: { gift_request_ids: giftRequestIds, gift_ids: giftIds, ec_order_no: ecOrderNo } }, cb)
  },
  // 將索取者列入品牌好物黑名單（互動卡取消贈送後可用）
  // reason 選填、上限 200 字（同後端 RecycleIdBrandBlacklistController::REASON_MAX_LENGTH），僅官方後台可見
  // 重複設定同一用戶不會報錯，後端 firstOrCreate 且保留最初填寫的理由
  addBrandBlacklist (userId, reason = '', cb) {
    return fetch('post', '/my/recycleIdBrandBlacklists', { data: { user_id: userId, reason } }, cb)
  },
  // 取得自己設過的品牌好物黑名單（企業端）
  // 回應為 { code, message, data: 分頁物件 }，每筆帶 user 關聯（id/nickname/pics）
  getBrandBlacklists (page = 1, perPage = 20, cb) {
    return fetch('get', `/my/recycleIdBrandBlacklists?page=${page}&perPage=${perPage}`, {}, cb)
  },
  // 將用戶從黑名單移除；不在名單中也會回成功（後端為條件式 delete）
  removeBrandBlacklist (userId, cb) {
    return fetch('delete', `/my/recycleIdBrandBlacklists/${userId}`, {}, cb)
  },
  // 出貨報表匯出（Excel）
  // giftRequestIds：僅匯出指定訂單；未帶則依寄件單建立時間區間，兩者皆無則匯出全部待寄出訂單
  // id 清單以逗號字串傳送，理由同 printWaybill（避免大量選取時觸及 URL 長度上限）
  exportPendingShip ({ giftRequestIds = [], from = '', to = '', keyword = '' } = {}) {
    const params = {}
    if (giftRequestIds.length) {
      params.gift_request_ids = giftRequestIds.join(',')
    }
    if (from) {
      params.shipsn_created_at_from = from
    }
    if (to) {
      params.shipsn_created_at_to = to
    }
    if (keyword) {
      params.keyword = keyword
    }
    return doGetFile('/brandGifts/requests/exportPendingShip', params)
  },
  // 批次列印託運單（限萊爾富 / 7-11，回傳 HTML 或 PDF）
  // giftRequestIds / giftIds 二選一，且所有訂單需為同一物流方式
  // id 清單以逗號字串傳送（gift_request_ids=1,2,3）而非 axios 預設的 ids[] 陣列：
  // 後端 normalizeIdList 兩種都吃，但逗號形式每筆 id 只佔約 6 字元（陣列形式為 25），
  // 大量選取時不易觸及 URL 長度上限
  printWaybill ({ giftRequestIds = [], giftIds = [], format = 'pdf', autoPrint = false } = {}) {
    const params = { format }
    if (autoPrint) {
      params.auto_print = 1
    }
    if (giftRequestIds.length) {
      params.gift_request_ids = giftRequestIds.join(',')
    } else if (giftIds.length) {
      params.gift_ids = giftIds.join(',')
    }
    return doGetFile('/brandGifts/requests/printWaybill', params)
  }
}
